import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { pushDataLayerEvent } from '../utils/analytics';
import './Register.css';

function HUGRegister() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register/hug`, { email, password });
      login(response.data.user, response.data.token);
      pushDataLayerEvent({
        event: 'sign_up',
        method: 'email',
        signup_type: 'hug',
        userEmail: response.data.user.email,
      });
      setMessage(`Registration successful! As a HUG partner, you've been awarded ${response.data.user.credits} credits (250 bonus + 50 regular).`);
      setTimeout(() => navigate('/dashboard'), 3000);
    } catch (error) {
      setError('Registration failed: ' + (error.response?.data?.error || error.message));
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-shapes">
            <div className="auth-shape shape1"></div>
            <div className="auth-shape shape2"></div>
            <div className="auth-shape shape3"></div>
          </div>
          <h1>HUG Special Offer</h1>
          <p className="auth-subtitle">Join ZipCode AutoFill with 250 bonus credits, exclusively for HUG partners</p>
        </div>
        
        {error && (
          <div className="auth-alert error">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
            <span>{error}</span>
          </div>
        )}
        
        {message && (
          <div className="auth-alert success">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
              <polyline points="22 4 12 14.01 9 11.01"></polyline>
            </svg>
            <span>{message}</span>
          </div>
        )}
        
        <div className="special-offer-badge">
          <span>HUG EXCLUSIVE</span>
          <span className="bonus-amount">+250 BONUS CREDITS</span>
        </div>
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="Create a strong password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <p className="password-hint">Must be at least 8 characters</p>
          </div>
          
          <button type="submit" className="auth-button hug-button">Create Account with Bonus</button>
        </form>
        
        <div className="auth-footer">
          <p>Already have an account? <Link to="/login">Sign in</Link></p>
        </div>
      </div>
    </div>
  );
}

export default HUGRegister; 
